module.exports = __webpack_public_path__ + "static/media/use13_ch01.0d420eac.png";